import { faCircleXmark } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import FileUpload from '../../../form/FileUpload';
import { useCallback, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import apiClient from '../../../../service/apiClient';

interface IPThumbnailId {
  id: { file: File; id: string } | null;
  setId: React.Dispatch<
    React.SetStateAction<{ file: File; id: string } | null>
  >;
}

/**
 * @author taulmax
 * @date 2024.10.13
 * @description 상품 등록 페이지 - 상품 이미지
 */
const PThumbnail = ({ id, setId }: IPThumbnailId) => {
  const [files, setFiles] = useState<File[]>([]);

  const validateA4Ratio = (width: number, height: number): boolean => {
    const ratio = height / width;
    const a4Ratio = 1.414; // A4 비율 (297/210)
    const tolerance = 0.05; // 5% 오차 허용
    return Math.abs(ratio - a4Ratio) <= tolerance;
  };

  useEffect(() => {
    const uploadProductImages = async (file: File) => {
      // 이미지 비율 검증
      const img = new Image();
      const reader = new FileReader();
      
      reader.onload = (e) => {
        img.onload = () => {
          if (!validateA4Ratio(img.width, img.height)) {
            toast.error('A4 비율(210:297)의 이미지를 업로드해주세요.');
            setFiles([]);
            return;
          }
          
          // 비율 검증 통과 시 업로드 진행
          const formData = new FormData();
          formData.append('file', file);
          
          apiClient.post('/upload-file/upload', formData)
            .then(response => {
              const tempFile = { file: file, id: response.data.id };
              setId(tempFile);
            })
            .catch(error => {
              console.error('이미지 업로드 실패:', error);
              toast.error('이미지 업로드를 실패했습니다.');
            });
        };
        img.src = e.target?.result as string;
      };
      reader.readAsDataURL(file);
    };

    if (files.length > 0) {
      files.forEach(file => uploadProductImages(file));
      setFiles([]);
    }
  }, [files, setId]);

  const onClickDelete = useCallback(() => {
    setId(null);
  }, [setId]);

  return (
    <div className="!space-y-4">
      {!id ? (
        <div className="!aspect-square !border-2 !border-dashed !border-gray-300 !rounded-lg !flex !items-center !justify-center hover:!border-gray-400 !transition-colors">
          <FileUpload setFiles={setFiles} accept="image/*" multiple={false} />
        </div>
      ) : (
        <div className="!relative">
          <div className="!aspect-square !rounded-lg !overflow-hidden !border-2 !border-gray-200">
            <img
              src={URL.createObjectURL(id.file)}
              alt="thumbnail"
              className="!w-full !h-full !object-cover"
            />
          </div>
          <button 
            className="!absolute !top-2 !right-2 !px-2 !py-1 !bg-red-500 !text-white !text-xs !rounded hover:!bg-red-600 !transition-colors !border-0" 
            onClick={onClickDelete}
            type="button"
          >
            삭제
          </button>
        </div>
      )}
    </div>
  );
};

export default PThumbnail;
